// extracted by mini-css-extract-plugin
var _1 = "BoolCell_detailsIcon__b0WO0";
export { _1 as "detailsIcon" }
